import React, { useId } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { SMLRouteNames } from '../../../routing/sml/SMLRoutes';
import { isNavItemActive, SMLNavGroup } from './smlNavigation';
import { SMLNavBadges } from './hooks/useNavBadges';
import { SidebarNavItem } from './SidebarNavItem';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole sidebar; each part uses its own slice of it */
import styles from '../SMLSideBar.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SidebarGroupProps {
  group: SMLNavGroup;
  screen: SMLRouteNames | undefined;
  badges: SMLNavBadges;
  params?: Record<string, string>;
}

/**
 * One group of the sidebar (design navigation-v2 1a, nav2.css .ws-grp2): a plain mono name, then
 * its 2 to 4 items. A group this short does not need to close. On the rail the name becomes a
 * hairline (1f) and the rail tooltip names the group and the item.
 */
const SidebarGroupComponent: React.FC<SidebarGroupProps> = ({ group, screen, badges, params }) => {
  const intl = useIntl();
  const label = intl.formatMessage(group.label);
  const headingId = useId();

  return (
    <li className={styles.group}>
      <div id={headingId} className={styles.groupHead}>
        {label}
      </div>
      <div className={styles.railKey} aria-hidden="true">
        <i />
      </div>
      <ul className={styles.list} aria-labelledby={headingId}>
        {group.items.map((item) => (
          <SidebarNavItem
            key={item.id}
            item={item}
            isActive={isNavItemActive(item, screen)}
            badge={badges.items[item.id]}
            tooltip={`${label} · ${intl.formatMessage(item.label)}`}
            params={params}
          />
        ))}
      </ul>
    </li>
  );
};

export const SidebarGroup = TypedMemo(SidebarGroupComponent);
